import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { motion, useViewportScroll, useTransform } from "framer-motion";

function ParallaxTitle({ title, intro }) {
  const formattedIntro = intro
    .split("\n\n")
    .map(paragraph => `<p>${paragraph.replace(/\n/g, "<br>")}</p>`)
    .join("");

  const { scrollY } = useViewportScroll();

  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);

  useEffect(() => {
    const el = document.querySelector(".js-hero");

    const setValues = () => {
      setElementTop(el.offsetTop);
      setElementBottom(el.offsetTop + el.offsetHeight);
    };
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  });

  const opacity = useTransform(scrollY, [elementTop, elementBottom], [1, 0]);
  const y = useTransform(scrollY, [elementTop, elementBottom], ["0vh", "50vh"]);

  return (
    <motion.section
      className="mx-auto text-white px-16 md:px-0 xl:px-0"
      style={{ opacity, y }}
    >
      <h1 className="mt-5 mb-2 sm:mb-2-5 pl-0 -ml-1-25">{title}</h1>
      <div
        className="mb-5 py-3 md:py-5 pr-5 pl-0 text-base md:text-2xl leading-7 md:leading-8 tracking-wide"
        dangerouslySetInnerHTML={{ __html: formattedIntro }}
      />
    </motion.section>
  );
}

ParallaxTitle.propTypes = {
  title: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired
};

export default ParallaxTitle;
